import React, { useState, useImperativeHandle, forwardRef, useRef } from "react"
import Api from "../../../../_helpers/Api"
import { trans } from "../../../../_providers/Translation"
import servicingHeadImage from "@/assets/img/contractors/icons/servicing-head.svg"

//images
import loader from "../../../../assets/img/loader.svg"
import Error from "../../../modals/messages/Error"
import Dropdown from "@/components/partials/Dropdown"
import Success from "../../../modals/messages/Success"
import moment from "moment"
import DatePicker from "@/components/partials/Date"

function ContractorServicing(props, ref) {
  const [popup, setPopup] = useState({
    overlay: false,
    modal: false,
    loading: false,
    data: null,
  })

  const [validations, setValidations] = useState(null)

  const successModalRef = useRef(null)
  const errorModalRef = useRef(null)
  const companyDropdownRef = useRef(null)

  useImperativeHandle(ref, () => ({
    open: () => {
      handleShow()
    },
    hide: () => {
      handleHide()
    },
  }))

  const handleShow = () => {
    companyDropdownRef.current?.refetchData()

    show()
  }

  const handleHide = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      data: null,
    }))

    setValidations(null)

    hide().then(() => {
      if (typeof props.onClose === "function") {
        props.onClose()
      }
    })
  }

  const show = async () => {
    return new Promise((resolve, reject) => {
      setPopup((prev) => ({
        ...prev,
        overlay: true,
      }))

      setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          overlay: true,
          modal: true,
        }))

        return resolve()
      }, 50)
    })
  }

  const hide = async () => {
    return new Promise((resolve, reject) => {
      setPopup((prev) => ({
        ...prev,
        modal: false,
        loading: false,
      }))

      setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          overlay: false,
          modal: false,
        }))

        return resolve()
      }, 50)
    })
  }

  const handleSave = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      loading: true,
    }))

    setValidations(null)

    let url = "contractors/appliance-servicing/companies/add"

    let data = new FormData(e.target)

    Api.post(url, data)
      .then((res) => {
        handleHide(e)

        if (typeof props.onSave === "function") {
          props.onSave(res.data)
        }
      })
      .catch((error) => {
        setPopup((prev) => ({
          ...prev,
          loading: false,
        }))

        let _err = error.response

        if (_err && _err.status && _err.status == 422) {
          for (let [input, err] of Object.entries(_err.data.errors)) {
            setValidations((prevState) => {
              return { ...prevState, [input]: true }
            })
          }
        }
      })
  }

  const handleInputChange = (e) => {
    let name = e.target.name
    let val = e.target.value

    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: val,
      },
    }))
  }

  const handleCompanyChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        company: data,
      },
    }))
  }

  const handleApplianceChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        appliancecategory: data,
        appliancebrand: {},
      },
    }))
  }

  const handleBrandChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        appliancebrand: data,
      },
    }))
  }

  return (
    <>
      <Success ref={successModalRef} mainMessage={trans("headings.success6")} />

      <Error ref={errorModalRef} mainMessage={trans("headings.error3")} />
      <div className={`${popup.overlay ? "visible" : ""} overlay`}>
        <form
          className={`${popup.modal ? "show" : ""} popup-primary popup-subscription-type medium`}
          onSubmit={handleSave}
        >
          <div className="head-new" style={{ marginBottom: "10px" }}>
            <img src={servicingHeadImage} alt="icon" />
            <div className="texts">
              <h2>{trans("headings.servicing")}</h2>
              <p>{trans("subheadings.servicing")}</p>
            </div>
            <span className="close" onClick={handleHide}></span>
          </div>

          <div className="row">
            <div className="col">
              <label>{trans("labels.name")}</label>
              <input
                type="text"
                name="name"
                value={popup.data?.name || ""}
                onChange={handleInputChange}
                className={validations && validations.name ? "validate" : ""}
              />
            </div>
            <div className="col">
              <label>{trans("labels.company")}</label>
              <Dropdown
                inputName=""
                inputValue={popup.data?.company?.name || ""}
                inputIdName="company_id"
                inputIdValue={popup.data?.company?.id || ""}
                url="contractors/dropdown-list"
                params={{
                  id: popup.data?.company?.id || null,
                  limit: 100,
                }}
                renderText={(data) => {
                  return data.name
                }}
                inputClassName={
                  validations && validations.company_id ? "validate" : ""
                }
                ref={companyDropdownRef}
                onChange={handleCompanyChange}
              />
            </div>
            <div
              className="col"
              style={{
                width: "fit-content",
              }}
            >
              <label>{trans("labels.dateOfFirstServicing")}</label>
              <DatePicker
                name="date_of_first_servicing"
                date={
                  popup.data?.date_of_first_servicing ||
                  moment().format("YYYY-MM-DD")
                }
                validate={Boolean(
                  validations && validations.date_of_first_servicing
                )}
                onDateChange={(date) =>
                  handleInputChange({
                    target: { name: "date_of_first_servicing", value: date || "" },
                  })
                }
                fullWidth
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col">
              <label>{trans("labels.category")}</label>
              <Dropdown
                inputName=""
                inputValue={popup.data?.appliancecategory?.name || ""}
                inputIdName="appliance_category_id"
                inputIdValue={popup.data?.appliancecategory?.id || ""}
                url="partners/categories/all"
                params={{
                  id: popup.data?.appliancecategory?.id || null,
                }}
                inputClassName={
                  validations && validations.appliance_category_id
                    ? "validate"
                    : ""
                }
                onChange={handleApplianceChange}
              />
            </div>
            <div className="col">
              <label>{trans("labels.make")}</label>
              <Dropdown
                inputName=""
                inputValue={popup.data?.appliancebrand?.name || ""}
                inputIdName="appliance_brand_id"
                inputIdValue={popup.data?.appliancebrand?.id || ""}
                url="partners/brands/all"
                params={{
                  id: popup.data?.appliancebrand?.id || null,
                }}
                inputClassName={
                  validations && validations.appliance_brand_id
                    ? "validate"
                    : ""
                }
                onChange={handleBrandChange}
              />
            </div>

            <div className="col">
              <label>{trans("labels.model")}</label>
              <input
                type="text"
                name="appliance_model"
                className={
                  validations && validations.appliance_model ? "validate" : ""
                }
                value={
                  popup.data && popup.data.appliance_model
                    ? popup.data.appliance_model
                    : ""
                }
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label>{trans("labels.serialNo")}</label>
              <input
                value={
                  popup.data && popup.data.serial_no ? popup.data.serial_no : ""
                }
                type="text"
                name="serial_no"
                onChange={handleInputChange}
              />
            </div>
            <div className="col">
              <label>{trans("labels.productCode")}</label>
              <input
                type="text"
                name="product_code"
                value={
                  popup.data && popup.data.product_code
                    ? popup.data.product_code
                    : ""
                }
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="footer align-right">
            {popup.loading ? (
              <img src={loader} alt="loading" />
            ) : (
              <>
                <button className="button" onClick={handleHide}>
                  {trans("buttons.cancel")}
                </button>
                <button className="button button-primary" type="submit">
                  {trans("buttons.save")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </>
  )
}

export default forwardRef(ContractorServicing)
